import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import StyleBox from './styled/box'

const Box = (props) => {
  const { className, style, children, width, height } = props
  return (
    <StyleBox
      className={clsx([
        className,
        'dark:bg-darkTheme-1100 bg-white border-gray-100 dark:border-none',
      ])}
      style={style}
      width={width}
      height={height}
    >
      {children}
    </StyleBox>
  )
}

// 参数类型
Box.propTypes = {
  style: PropTypes.shape({}),
  className: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
}
Box.defaultProps = {
  className: undefined,
  style: undefined,
  children: undefined,
  width: undefined,
  height: undefined,
}
export default Box
